import * as actions from './actions'
import * as sagas from './sagas'
import * as selectors from './selectors'
import reducer from './reducer'

export default {
  actions,
  reducer,
  sagas,
  selectors,
}
